var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:this.viewport.label,attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"loader"}},[_c('global-loader',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}]})],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }